<div class="bg-grey-200 page-padding-y pb-3">
  <div class="page-padding-x">
    <h3 id="h-ballot-dashboard" class="pl-4">Ballots</h3>
  </div>
</div>

<div class="flex-1 pt-6 bg-grey-100 page-padding-x">
  <h5 id="title-ballot-dashboard" class="pl-4" id="create-ballot-title">Create one of the ballot types below</h5>
  <div class="flex flex-wrap">
    <div class="w-full sm:w-1/2 lg:w-1/3 p-4">
      <div class="text-brand-darkBlue bg-white p-6 rounded-lg shadow-lg cursor-pointer" (click)="navigateTo('CIB')">
        <h6 class="text-ellipsis whitespace-nowrap overflow-hidden mb-1 body-default-bold" id="CIB">
          Committee Internal Ballot
        </h6>
      </div>
    </div>
    <div class="w-full sm:w-1/2 lg:w-1/3 p-4">
      <div class="text-brand-darkBlue bg-white p-6 rounded-lg shadow-lg cursor-pointer" (click)="navigateTo('SR')">
        <h6 class="text-ellipsis whitespace-nowrap overflow-hidden mb-1 body-default-bold" id="SR">
          Systematic Review Ballot
        </h6>
      </div>
    </div>
    <div class="w-full sm:w-1/2 lg:w-1/3 p-4">
      <div class="text-brand-darkBlue bg-white p-6 rounded-lg shadow-lg cursor-pointer" (click)="navigateTo('IEC')">
        <h6 class="text-ellipsis whitespace-nowrap overflow-hidden mb-1 body-default-bold" id="IEC">
          IEC Ballot
        </h6>
      </div>
    </div>
  </div>
</div>

